import React, { useState } from "react";
import Address from "./Address";
import PaymentSuccess from "./Paymentsuccess";
import PaymentFailed from "./PaymentFailed";
import decryptCookieData from "./Functions/decryptCookieData";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getDistance } from "geolib";
import getCoordinatesFromAddress from "./utils/geocodeAddress";


const Checkout = () => {
    const [isEditingContact, setIsEditingContact] = useState(false);
    const [email, setEmail] = useState("");
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
    const phonenumber = userData?.mobile || ""
    const [mobile, setMobile] = useState(phonenumber);
    const [showOptions, setShowOptions] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("Pay now");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [percentage, setPercentage] = useState(0)
    const [advanceAmount, setAdvanceAmount] = useState(0);
    const [freeDeliveryRules, setFreeDeliveryRules] = useState([]);


    const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
    const [validationError, setValidationError] = useState("");
    const [vendorAddress, setVendorAddress] = useState("")
    const [deliveryRules, setDeliveryRules] = useState([]);
    const [distanceInKm, setDistanceInKm] = useState(null);




    const [checkoutInfo, setCheckoutInfo] = useState(null);
    const url = process.env.REACT_APP_API_URL


    useEffect(() => {
        const data = JSON.parse(localStorage.getItem("checkout_data"));
        setCheckoutInfo(data);
    }, []);



    const [data, setData] = useState({
        location_user: "",
        new_address: "",
        city: "",
        pincode: "",
        user_id: userData.user_id,
        user_name: userData.full_name,
        main_id: process.env.REACT_APP_PERFUME_ID,
        number: mobile,
        area: ""
    })
    const [formData, setFormData] = useState(null);

    // useEffect(() => {
    //     if (checkoutInfo && selectedBillingAddress && selectedShippingAddress) {
    //         setFormData({
    //             user_id: userData?.user_id,
    //             order_id: "",
    //             payment_capture: "",
    //             currency: "",
    //             user_name: userData?.full_name,
    //             amountbeforediscount: checkoutInfo.totalBeforeDiscount,
    //             amountafterdiscount: checkoutInfo.totalAfterDiscount,
    //             cart_products: checkoutInfo.products,
    //             couponapplied: checkoutInfo.isCouponApplied,
    //             coupon_code: checkoutInfo.coupon,
    //             discountprice: checkoutInfo.discountAmount,
    //             billing_address: selectedBillingAddress,
    //             shipping_address: selectedShippingAddress,
    //             main_id: process.env.REACT_APP_PERFUME_ID
    //         });
    //     }
    // }, [checkoutInfo, selectedShippingAddress, selectedBillingAddress]);

    // useEffect(() => {
    //     if (checkoutInfo && selectedBillingAddress && selectedShippingAddress) {
    //         const totalAmount = checkoutInfo.totalAfterDiscount || 0;
    //         const deliveryCharge = Math.round((totalAmount * percentage) / 100);
    //         const remainingPrice = totalAmount - deliveryCharge;

    //         setFormData({
    //             user_id: userData?.user_id,
    //             order_id: "",
    //             payment_capture: "",
    //             currency: "",
    //             user_name: userData?.full_name,
    //             amountbeforediscount: checkoutInfo.totalBeforeDiscount,
    //             amountafterdiscount: totalAmount,
    //             delivery_charge: deliveryCharge,
    //             remaining_price: remainingPrice,
    //             cart_products: checkoutInfo.products,
    //             couponapplied: checkoutInfo.isCouponApplied,
    //             coupon_code: checkoutInfo.coupon,
    //             discountprice: checkoutInfo.discountAmount,
    //             billing_address: selectedBillingAddress,
    //             shipping_address: selectedShippingAddress,
    //             main_id: process.env.REACT_APP_PERFUME_ID
    //         });
    //     }
    // }, [checkoutInfo, selectedShippingAddress, selectedBillingAddress, percentage]);


    useEffect(() => {
        if (checkoutInfo && selectedBillingAddress && selectedShippingAddress) {
            const totalAmount = checkoutInfo.totalAfterDiscount || 0;
            const deliveryCharge = calculateDeliveryCharge();
            // add this just before setFormData
            let upfrontAmount = totalAmount;
            let remainingPrice = 0;

            if (selectedPayment === "Pay on delivery" && percentage > 0) {
                upfrontAmount = Math.round((totalAmount * percentage) / 100);
                remainingPrice = totalAmount - upfrontAmount;
            }

            const paymentAdavnce = Number(upfrontAmount)
            setAdvanceAmount(paymentAdavnce);
            setFormData({
                user_id: userData?.user_id,
                order_id: "",
                payment_capture: "",
                currency: "",
                user_name: userData?.full_name,
                amountbeforediscount: checkoutInfo.totalBeforeDiscount,
                amountafterdiscount: Number(upfrontAmount) + Number(deliveryCharge || 0),
                deliveryCharge: deliveryCharge,
                remaining_amount: remainingPrice,
                cart_products: checkoutInfo.products,
                couponapplied: checkoutInfo.isCouponApplied,
                coupon_code: checkoutInfo.coupon,
                discountprice: checkoutInfo.discountAmount,
                billing_address: selectedBillingAddress,
                shipping_address: selectedShippingAddress,
                payment_mode: selectedPayment,
                totalAmountbeforePay: Number(checkoutInfo.totalAfterDiscount) + Number(deliveryCharge || 0),
                main_id: process.env.REACT_APP_PERFUME_ID
            });
        }
    }, [checkoutInfo, selectedBillingAddress, selectedShippingAddress, percentage, vendorAddress, deliveryRules, selectedPayment]);


    const toggleOptions = () => {
        setShowOptions(!showOptions);
    };

    const selectPayment = (option) => {
        setSelectedPayment(option);
        setShowOptions(false); // Close options after selection
    };



    const fetchData = async () => {
        try {
            const response = await fetch(`${url}/registeruser/single/${userData.user_id}`)
            const res = await response.json();
            setMobile(res.mobile)
        } catch (error) {
            console.log(error)
        }
    }


    const submitMobile = async () => {
        setIsEditingContact(false)
        try {
            const response = await fetch(`${url}/registeruser/api/user/${userData.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ mobile })
            })
            const res = await response.json();
            if (res.success) {
                await fetchData();
            }
        } catch (error) {
            console.log(error)
        }
    }
    // const placeOrder = async () => {
    //     if (!formData) return;

    //     try {
    //         const response = await fetch(`${url}/payment`, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify(formData),
    //         });

    //         const result = await response.json();

    //         if (result.success) {
    //             openRazorpay(result.razorpay_order, result.order_id);
    //         } else {
    //             toast.error("Failed to create Razorpay order");
    //         }
    //     } catch (err) {
    //         console.error("Error placing order:", err);
    //         toast.error("Error during checkout");
    //     }
    // };

    const placeOrder = async () => {
        if (!selectedBillingAddress) {
            setValidationError("Please select a billing address.");
            toast.error("Please select a billing address.")
            return;
        }

        if (!selectedShippingAddress) {
            setValidationError("Please select a shipping address.");
            toast.error("Please select a shipping address.")
            return;
        }

        if (!mobile || mobile.length !== 10) {
            setValidationError("Please enter a valid 10-digit mobile number.");
            toast.error("Please enter a valid 10-digit mobile number.")
            return;
        }

        setValidationError(""); // Clear any previous errors

        try {
            const response = await fetch(`${url}/payment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.success) {
                openRazorpay(result.razorpay_order, result.order_id);
            } else {
                toast.error("Failed to create Razorpay order");
            }
        } catch (err) {
            console.error("Error placing order:", err);
            toast.error("Error during checkout");
        }
    };
    const openRazorpay = (razorpayOrder, order_id) => {
        const options = {
            key: "rzp_test_zEWr4dOpfx4w2F",
            amount: razorpayOrder.amount,
            currency: razorpayOrder.currency,
            name: "Perfume",
            description: "Order Payment",
            order_id: razorpayOrder.id,
            handler: async function (response) {
                const verifyRes = await fetch(`${url}/payment/verify`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                    }),
                });

                const verifyData = await verifyRes.json();
                if (verifyData.success) {
                    window.location.href = `/payment-success/${order_id}`; // ✅ Redirect on success
                } else {
                    window.location.href = `/payment-failed/${order_id}`; // ❌ Redirect on failure
                }
            },
            prefill: {
                name: userData?.full_name,
                email: userData?.email,
                contact: mobile,
            },
            theme: { color: "#3399cc" },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    };



    const calculateDeliveryCharge = () => {
        if (
            !selectedShippingAddress ||
            !vendorAddress ||
            !deliveryRules.length ||
            !vendorAddress?.latitude ||
            !vendorAddress?.longitude ||
            !selectedShippingAddress.latitude ||
            !selectedShippingAddress.longitude
        ) {
            return 0;
        }

        const distanceMeters = getDistance(
            {
                latitude: parseFloat(vendorAddress?.latitude),
                longitude: parseFloat(vendorAddress?.longitude),
            },
            {
                latitude: parseFloat(selectedShippingAddress.latitude),
                longitude: parseFloat(selectedShippingAddress.longitude),
            }
        );

        const distanceKm = distanceMeters / 1000;
        let roundedDistance;

        if (distanceKm > 0.1 && distanceKm < 1) {
            roundedDistance = 1;
        } else {
            roundedDistance = Math.round(distanceKm);
        }

        console.log(roundedDistance);
        setDistanceInKm(roundedDistance);

        const cartTotal = checkoutInfo?.totalAfterDiscount || 0;

        // ✅ Check if any free delivery rule applies
        console.log(freeDeliveryRules)
        const freeRule = freeDeliveryRules.find(rule =>
            distanceKm >= rule.min_kilometer &&
            distanceKm <= rule.max_kilometer &&
            cartTotal >= rule.freedelivery_price
        );
        console.log(freeRule)
        if (freeRule) {
            return 0; // 🎉 Free delivery
        }

        // ❌ Else, use delivery rules normally
        const matchedRule = deliveryRules.find(
            (rule) =>
                distanceKm >= rule.min_kilometer &&
                distanceKm <= rule.max_kilometer &&
                rule.status === "Active"
        );

        return matchedRule?.delivery_price || 0;
    };



    const fetchDeliveryPayData = async () => {
        try {
            const response = await fetch(`${url}/deliverypaybefore/single/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();
            if (res?.help?.delivery_percentage) {
                setPercentage(Number(res.help.delivery_percentage));
            } else {
                setPercentage(0);
            }
        } catch (error) {
            console.error("Error fetching delivery data:", error);
            setPercentage(0);
        }
    };

    const fetchDelivery = async () => {
        try {
            const response = await fetch(`${url}/delivery-price/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();
            setDeliveryRules(res.data || []);
        } catch (error) {
            console.log("Delivery price fetch error:", error);
            setDeliveryRules([]);
        }
    };


    const fetchDataAddressAdmin = async () => {
        try {
            const response = await fetch(`${url}/register/officesingle/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            setVendorAddress(res.google_address)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const fetchCoordinatesForAddresses = async () => {
            // Only geocode if distance is needed and not already present
            if (
                (!vendorAddress?.latitude || !vendorAddress?.longitude) &&
                typeof vendorAddress === "string"
            ) {
                const coords = await getCoordinatesFromAddress(vendorAddress);
                if (coords) {
                    setVendorAddress(prev => ({
                        ...coords, // add latitude, longitude
                        raw: vendorAddress // optionally keep raw string
                    }));
                }
            }

            if (
                selectedShippingAddress &&
                (!selectedShippingAddress.latitude || !selectedShippingAddress.longitude)
            ) {
                const coords = await getCoordinatesFromAddress(selectedShippingAddress.area);
                if (coords) {
                    setSelectedShippingAddress(prev => ({
                        ...prev,
                        latitude: coords.latitude,
                        longitude: coords.longitude,
                    }));
                }
            }
        };

        fetchCoordinatesForAddresses();
    }, [vendorAddress, selectedShippingAddress]);


    const deliveryCheckfree = async () => {
        try {
            const response = await fetch(`${url}/freedelivery/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            if (Array.isArray(res.data)) {
                setFreeDeliveryRules(res.data);
            }
        } catch (error) {
            console.log(error)
            setFreeDeliveryRules([]);
        }
    }
    useEffect(() => {
        fetchData();
        fetchDeliveryPayData();
        fetchDelivery();
        fetchDataAddressAdmin();
        deliveryCheckfree();
    }, [])




    return (
        <>
            <ToastContainer position="top-center" autoClose={3000} />
            <div className="checkout-perfume">
                <div className="cart-columns-perfume">
                    <div className="address-container cart-column1-perfume">
                        <Address data={data} setData={setData} selectedBillingAddress={selectedBillingAddress} setSelectedShippingAddress={setSelectedShippingAddress} setSelectedBillingAddress={setSelectedBillingAddress} selectedShippingAddress={selectedShippingAddress} />
                        <div className="contact-info">
                            <h3>Contact Information</h3>

                            {isEditingContact ? (
                                <div className="contact-edit">
                                    <div className="contact-edit-input">
                                        <input
                                            type="email"
                                            value={userData.email}
                                            // onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter email"
                                            disabled
                                        />
                                        <input
                                            type="text"
                                            value={mobile}
                                            onChange={(e) => setMobile(e.target.value)}
                                            placeholder="Enter mobile number"
                                        />
                                    </div>
                                    <button onClick={submitMobile}>Save</button>
                                </div>
                            ) : (
                                <p className="contact-details">
                                    <strong>Email:</strong> {userData.email} | <strong>Mobile:</strong> {mobile || phonenumber}
                                </p>
                            )}

                            {!isEditingContact && (
                                <button onClick={(e) => { e.preventDefault(); setIsEditingContact(true); }}>
                                    Change
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="cart-column2-perfume">
                        <div className="cart-column2-header-perfume">
                            <h3>Order Summary</h3>
                        </div>
                        <div className="cart-column2-total-perfume">
                            <div className="cart-total-labels">
                                <p><strong>Total Price</strong></p>
                                <p>Original Price</p>
                                <p>Delivery Charge</p>
                                {(percentage > 0 && selectedPayment === "Pay on delivery") && (
                                    <p>Advance Payable</p>
                                )}
                            </div>
                            <div className="cart-total-value">
                                <p><strong>₹{checkoutInfo?.totalAfterDiscount}</strong></p>
                                <p>₹{checkoutInfo?.totalBeforeDiscount}</p>
                                <p>₹{formData?.deliveryCharge || 0}</p>
                                {(percentage > 0 && selectedPayment === "Pay on delivery") && (
                                    <p>₹{advanceAmount}</p>
                                )}
                            </div>
                        </div>

                        <div className="payment-container">
                            <div className="payment-text" onClick={toggleOptions}>
                                <div>Pay using</div>
                                <div>{selectedPayment} <i class="fa-solid fa-angle-down"></i></div>
                            </div>

                            {showOptions && (
                                <div className="payment-options">
                                    <div onClick={() => selectPayment("Pay on delivery")}>Pay on delivery</div>
                                    <div onClick={() => selectPayment("Pay now")}>Pay now</div>
                                </div>
                            )}

                            <button className="payment-button" onClick={placeOrder}>Place order</button>
                        </div>
                        {(percentage > 0 && selectedPayment === "Pay on delivery") && (
                            <div className="delivery-pay-note" style={{ marginTop: "10px", color: "#d9534f", fontWeight: "bold", textAlign: "center", fontSize: "15px" }}>
                                You need to pay {percentage}% now online.
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showSuccessModal && <PaymentFailed onClose={() => setShowSuccessModal(false)} />}
        </>
    );
};

export default Checkout;
